<template>
  <!-- 订单管理 -->
  <div class="el-card  pd20">
    <!-- add---新增 -->
    <div class="box">
      <div class="cancel-box">
        <el-button type="info" icon="el-icon-arrow-left" @click="$router.go(-1)" size="medium">返回推广列表</el-button>
      </div>
      <el-divider></el-divider>
      <!-- 基本信息 -->
      <h2 class="basic-h2">推广员基本信息</h2>
      <div class="basic-information">
        <!--  -->
        <div class="information-group">
          <label for="">头像/昵称：</label>
          <img class="userImg" :src="form.headimgurl" alt=""> {{form.nickname}}
        </div>
        <!--  -->
        <div class="information-group">
          <label for="">累计邀请：</label>
          {{form.view_count}}人
        </div>
        <!--  -->
        <div class="information-group">
          <label for="">累计客户：</label>
          {{form.buy_count}}人
        </div>
        <!--  -->
        <div class="information-group">
          <label for="">累计收益：</label>
          {{form.total_fee}}元
        </div>
        <!--  -->
        <div class="information-group">
          <label for="">加入时间：</label>
          {{form.create_time}}
        </div>
      </div>
    </div>
    <!-- <el-divider></el-divider> -->
    <!--  -->
    <el-tabs type="border-card" v-model="state" @tab-click="checkInvited">
      <el-tab-pane label="累计客户列表" :name="1">
        <div class="pane-box">
          <el-table :data="list" border style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="100" label="序号"></el-table-column>
            <el-table-column label="用户昵称">
              <template slot-scope="scope">
                <div class="userinfo">
                  <img :src="scope.row.headimgurl" alt="">{{scope.row.nickname}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="course_name" label="课程名称"> </el-table-column>
            <el-table-column width="90" label="订单类型">
              <template slot-scope="scope">
                {{orderType(scope.row.order_type)}}
              </template>
            </el-table-column>
            <el-table-column prop="fee" label="返现金额"> </el-table-column>
            <el-table-column prop="pay_time" label="购买时间"> </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!--  -->
      <el-tab-pane label="累计邀请列表" :name="2">
        <div class="pane-box">
          <el-table :data="list" border style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="100" label="序号"></el-table-column>
            <el-table-column label="用户昵称">
              <template slot-scope="scope">
                <div class="userinfo">
                  <img :src="scope.row.headimgurl" alt="">{{scope.row.nickname}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="course_name" label="课程名称"> </el-table-column>
            <el-table-column prop="view_time" label="首次查看时间"> </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  promoterDetail,
  promoterInvited
} from "@/api/operating";
export default {
  data() {
      return {
        pages: {},
        form: {
          buy_count: null,
          create_time: "",
          headimgurl: "",
          nickname: "",
          total_fee: null,
          view_count: null
        },
        list: [],
        //
        state: 1
      }
    },
    methods: {
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },// 订单类型
      orderType(val) {
        if (val == 1) {
          return '普通订单'
        }
        if (val == 2) {
          return '拼团订单'
        }
        if (val == 100) {
          return '推广员订单'
        }
      },

      pullData() {
        this.$showLoading();
        // 推广员信息
        let arr1 = promoterDetail({
          id: this.$route.query.id
        }).then((data) => {
          this.form = data.list;
          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
        // 推广员邀请列表
        this.checkInvited();

      },
      checkInvited() {
        promoterInvited({
          id: this.$route.query.id,
          state: this.state,
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25, //每页数量，默认25
        }).then((data) => {
          this.list = data.list;
        })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.box {
  margin-bottom: 30px;
}

.content {
  padding: 20px;
}

.userinfo {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.basic-h2 {
  font-size: 16px;
}

.basic-information {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .information-group {
    line-height: 40px;
    width: 33.33%;
    margin-top: 20px;
    font-size: 14px;
  }
}

.pane-box {
  padding: 20px;
}

.userImg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
}
</style>
